export default "__VITE_ASSET__BU56ejIu__"